// extracted by mini-css-extract-plugin
export var sectionContainer = "services-module--section-container--6acdf";